// extracted by mini-css-extract-plugin
export default {"searchInput":"positionName_searchInput__jvj8O"};